import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
import { computed } from 'vue';
import { supplierFlagStore } from '@dashboardApp/stores/SupplierFlagStore';
export default {
  __name: 'FlagButton',
  props: {
    supplierId: {
      type: [Number, String],
      required: true
    },
    supplierWebsite: {
      type: String,
      required: true
    },
    matches: {
      type: String,
      "default": ''
    },
    terms: {
      type: String,
      "default": ''
    },
    btnClass: {
      type: String,
      "default": 'btn border-0 font-size-12 sh-color-gray-3 py-1 btn-flag'
    },
    disabled: {
      type: Boolean,
      "default": false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var computedClasses = computed(function () {
      var classes = [props.btnClass];
      if (props.disabled) {
        classes.push('disabled');
      }
      return classes;
    });
    function assignSupplierData() {
      supplierFlagStore.id = props.supplierId;
      supplierFlagStore.website = props.supplierWebsite;
      supplierFlagStore.matches = props.matches;
      supplierFlagStore.terms = props.terms;
    }
    return function (_ctx, _cache) {
      var _directive_b_modal = _resolveDirective("b-modal");
      return _withDirectives((_openBlock(), _createElementBlock("a", {
        onClick: assignSupplierData,
        "class": _normalizeClass(computedClasses.value),
        role: "button",
        tabindex: "-1"
      }, [_renderSlot(_ctx.$slots, "default", {}, function () {
        return [_cache[0] || (_cache[0] = _createTextVNode("Flag supplier"))];
      })], 2)), [[_directive_b_modal, void 0, void 0, {
        supplierFlag: true
      }]]);
    };
  }
};